<template>
   <div v-if="!mostrarAlbaran">
      <h4 class="card-title mb-4">Pedidos por Zona {{ zoneSelected }}</h4>
      <div class="row mt-4">
         <div class="col-sm-12 col-md-6">
            <div id="tickets-table_length" class="dataTables_length">
               <label class="d-inline-flex align-items-center">
                  Ver 
               <b-form-select v-model="perPage" class="mx-1" size="sm" :options="pageOptions"></b-form-select>registros
               </label>
            </div>
         </div>

         <div class="col-sm-12 col-md-6 mb-3">
            <div id="tickets-table_filter" class="dataTables_filter text-md-right">
               <label class="d-inline-flex align-items-center" style="width: 100%;">
                  Búsqueda:
                  <b-form-input v-model="filter" type="search" placeholder="Buscar..." class="form-control form-control-sm ml-2"></b-form-input>
               </label>
            </div>
         </div>
      </div>
      <div class="table-responsive mb-0">
         <b-table :items="orders" :fields="fields" responsive="sm" :per-page="perPage" :current-page="currentPage" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :filter="filter" :filter-included-fields="filterOn" @filtered="onFiltered">
            <template v-slot:cell(detalles)="data">
               <button @click="detalle(data.item)" type="button" class="btn btn-danger btn-sm btn-rounded">Detalle</button>
            </template>
         </b-table>
      </div>
      <div class="row">
         <div class="col">
            <div class="dataTables_paginate paging_simple_numbers float-right">
               <ul class="pagination pagination-rounded mb-0">
                  <!-- pagination -->
                  <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
               </ul>
            </div>
         </div>
      </div>
   </div>
   <div v-else>
      <albaran :order="order"></albaran>
   </div>
</template>

<script>
   import Albaran from '@/components/albaran.vue'
   import axios from 'axios'
   //import VuePaginate from 'vue-paginate'

   export default {
      props: {
         orders: {
            type: Array,
            default: function() {
            return [];
            }
         }
      },
      data() {
         return {
            pageOptions: [10, 25, 50, 100],
            perPage: 10,
            filter: null,
            filterOn: [],
            fields: [
               { key: "pedido", sortable: true },
               { key: "cód. cliente", sortable: true },
               { key: "nombre cliente", sortable: true },
               { key: "cód. dep.", sortable: true },
               { key: "punto venta", sortable: true },
               { key: "fecha", sortable: true },
               { key: "detalles", sortable: true },
            ],
            sortBy: "pedido",
            sortDesc: false,
            currentPage: 1,
            totalRows: 1,
            mostrarAlbaran: false,
            order: ''
         }
      },
      methods: {
         onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
         },
         async detalle(order) {
            let pedido = order.id
            let params = "json="+JSON.stringify({ pedido })
            var items = []
            
            await axios({url: 'https://portal.asein.es/api-v2/cargar-lineas', data: params, method: 'POST' })
            .then(resp => {
               items = resp.data
            })
            .catch(err => {
               console.log(err)
            })

            this.mostrarAlbaran = true
            this.order = { id: order['id'], fecha: order['fecha'], repre: this.$store.state.user.selectedZone, codcli: '', coddep: '', empresa: order['nombre cliente'], pv: order['punto venta'], items: items, observaciones: order['observaciones'] }
         }
      },
      computed: {
         rows() {
            return this.orders.length;
         },
         zoneSelected() {
            return this.$store.state.user.selectedZone
         },
      },
      components: { Albaran }
   };
</script>